// カートページの追加購入・プレゼント行を「缶換算数」と同期させる。
// 缶換算数 = _item_type: can の行（1換算）＋「複数缶換算のコレクション」の行（設定値換算）。
// 設定はすべて window.PerkConfig（perk-center セクションが全ページに出力）から受け取る。
(() => {
  // PerkConfig はインラインscriptで定義済み（このファイルはdeferのため必ず後に実行される）
  const perkConfig = window.PerkConfig || {};
  const boxEquivalents = perkConfig.boxEquivalents || {};
  const perkGifts = Array.isArray(perkConfig.gifts) ? perkConfig.gifts : [];
  let syncInProgress = false;
  // 決済ボタンをサーバー側の補正完了までブロックするためのフラグ。
  // ネットワークが遅い環境で「缶を減らした直後に決済へ進む」等が起きても、
  // 決済遷移の直前にカートの最新状態を取得して缶バッジ数を必ず補正してから送信する。
  let checkoutSubmitBypass = false;

  // 進行中のカート更新リクエスト（数量変更・追加・削除）の数。
  // テーマ本体（cart.js等）が送るリクエストも含めて fetch をラップして数える。
  // 決済前チェックは「カートの最新状態を取得」するだけでは不十分で、
  // 数量変更リクエストがまだ機内にある間に取得すると変更前の古いカートが
  // 返ってきてしまう（＝レースコンディションの正体）。そのため全ての
  // カート更新が完了するのを待ってからチェックする。
  let inFlightCartMutations = 0;
  const originalFetch = window.fetch;
  window.fetch = function (input) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    if (!/\/cart\/(change|update|add|clear)/.test(url)) {
      return originalFetch.apply(this, arguments);
    }
    inFlightCartMutations++;
    setCheckoutDisabled(true);
    return originalFetch.apply(this, arguments).finally(() => {
      inFlightCartMutations--;
      scheduleCheckoutEnable();
    });
  };

  // --- 決済ボタンの活性制御 ---
  // カート更新の通信中や数量変更の直後（デバウンス待ち）は決済ボタンを無効化し、
  // 未確定の状態で決済へ進めないようにする。落ち着いたら自動で再有効化する。
  function setCheckoutDisabled(disabled) {
    document.querySelectorAll('button[name="checkout"]').forEach((btn) => {
      btn.disabled = disabled;
    });
  }

  let checkoutEnableTimer = null;
  function scheduleCheckoutEnable() {
    if (checkoutEnableTimer) clearTimeout(checkoutEnableTimer);
    checkoutEnableTimer = setTimeout(() => {
      if (inFlightCartMutations === 0 && !syncInProgress) {
        setCheckoutDisabled(false);
      } else {
        scheduleCheckoutEnable();
      }
    }, 500);
  }

  // 缶の数量入力が変わった瞬間（テーマ本体の送信デバウンスより前）にボタンを無効化する。
  // interceptCanQuantityChange が確認ダイアログでキャンセルした場合は
  // stopPropagation によりこのリスナーは呼ばれないため、誤って無効化されない。
  function markCanEditPending(event) {
    const input = event.target.closest(".cart-item .quantity__input");
    if (!input || rowCanEquiv(input.closest(".cart-item")) < 1) return;
    setCheckoutDisabled(true);
    scheduleCheckoutEnable();
  }

  // カート行1つあたりの缶換算数。まとめ買い経由（_item_type: can）は1、
  // それ以外は boxEquivalents（特典センターの缶換算コレクション）から解決する。
  function rowCanEquiv(row) {
    if (!row) return 0;
    if (row.getAttribute("data-item-type") === "can") return 1;
    return boxEquivalents[row.getAttribute("data-product-id") || ""] || 0;
  }

  // cart.js のアイテム1つあたりの缶換算数
  function itemCanEquiv(item) {
    const itemType = item.properties ? item.properties["_item_type"] : null;
    if (itemType === "can") return 1;
    return boxEquivalents[String(item.product_id)] || 0;
  }

  // カート更新リクエストと反応的な補正処理がすべて落ち着くまで待つ（上限あり）
  function waitForCartIdle(timeoutMs) {
    const start = Date.now();
    return new Promise((resolve) => {
      (function check() {
        const idle = inFlightCartMutations === 0 && !syncInProgress;
        if (idle || Date.now() - start > timeoutMs) {
          resolve();
        } else {
          setTimeout(check, 100);
        }
      })();
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.cartData && event.cartData.items) {
          syncGiftBadge(event.cartData.items);
        }
      });
    }

    // ページ表示時にも整合性を確認（カート外での数量変更後の再訪など）
    fetch(getRootUrl() + "cart.js")
      .then((res) => res.json())
      .then((cart) => syncGiftBadge(cart.items))
      .catch(() => {});
  });

  // 缶を0個にする操作をキャプチャ段階で捕捉し、確認ダイアログを挟む
  document.addEventListener("change", interceptCanQuantityChange, true);
  document.addEventListener("click", interceptCanRemoveClick, true);
  // 缶の数量変更を検知して決済ボタンを一時無効化する（intercept の後に登録すること）
  document.addEventListener("change", markCanEditPending, true);
  // 決済ボタン押下をキャプチャ段階で捕捉し、缶バッジの補正が終わるまで送信を止める
  document.addEventListener("submit", interceptCheckoutSubmit, true);

  function getRootUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
  }

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // 画面上の缶換算数（入力欄の現在値＝ユーザーの意図）を合計する
  function domCanTotalCurrent() {
    let total = 0;
    document.querySelectorAll(".cart-item .quantity__input").forEach((input) => {
      const equiv = rowCanEquiv(input.closest(".cart-item"));
      if (equiv > 0) total += (parseInt(input.value, 10) || 0) * equiv;
    });
    return total;
  }

  function serverCanTotal(cart) {
    let total = 0;
    cart.items.forEach((item) => {
      total += itemCanEquiv(item) * item.quantity;
    });
    return total;
  }

  // 「確定済みのカート」を取得する。テーマ本体の数量変更はデバウンス（送信待ち）や
  // 通信中のことがあり、その間に取得すると変更前の古いカートが返る。
  // 画面上の缶数とサーバー上の缶数が一致するまで再取得して確定を待つ。
  function fetchSettledCart(retries) {
    return fetch(getRootUrl() + "cart.js", { cache: "no-store" })
      .then((res) => res.json())
      .then((cart) => {
        if (retries > 0 && domCanTotalCurrent() !== serverCanTotal(cart)) {
          return delay(300).then(() => fetchSettledCart(retries - 1));
        }
        return cart;
      });
  }

  function cartBadgeRowsExist() {
    return (
      document.querySelector('.cart-item[data-item-type="badge"], .cart-item[data-item-type="gift"]') !== null
    );
  }

  function canTotalFromDom() {
    let total = 0;
    document.querySelectorAll(".cart-item .quantity__input").forEach((input) => {
      const equiv = rowCanEquiv(input.closest(".cart-item"));
      if (equiv > 0) total += (parseInt(input.getAttribute("value"), 10) || 0) * equiv;
    });
    return total;
  }

  // 行の商品名を取得する（.cart-item__details 内の商品タイトル要素）
  function rowProductTitle(row) {
    const titleEl = row && row.querySelector(".cart-item__details .h4");
    return (titleEl && titleEl.textContent.trim()) || "対象商品";
  }

  function buildConfirmMessage(productTitle) {
    const template =
      perkConfig.confirmMessage ||
      "[商品名]をカートから減らすと条件を満たさなくなり、カートに追加されている特典は削除されます。よろしいですか？";
    return template.replace(/\[商品名\]/g, productTitle);
  }

  // ブラウザ標準confirm()の代わりに特典センターのモーダルで確認する（Promise<boolean>）
  function confirmBadgeRemoval(productTitle) {
    const message = buildConfirmMessage(productTitle);
    if (window.PerkFab && window.PerkFab.confirmRemoval) {
      return window.PerkFab.confirmRemoval(message);
    }
    // 特典センターが読み込まれていない場合の保険
    return Promise.resolve(window.confirm(message));
  }

  // この操作後の缶換算数で特典が失われるかどうかを判定する。
  // ・合計0 → 追加購入・プレゼントの行がすべて削除される
  // ・プレゼント行があり、いずれかの施策の条件数を下回る → プレゼントが削除される
  function wouldLosePerk(newTotal) {
    if (newTotal <= 0 && cartBadgeRowsExist()) return true;
    if (!document.querySelector('.cart-item[data-item-type="gift"]')) return false;
    return perkGifts.some((gift) => newTotal < (parseInt(gift.threshold, 10) || 6));
  }

  function interceptCanQuantityChange(event) {
    const input = event.target.closest(".cart-item .quantity__input");
    if (!input) return;

    // 確認モーダルで「削除する」を選んだ後の再送信はそのまま通す
    if (input.dataset.perkConfirmBypass === "1") {
      delete input.dataset.perkConfirmBypass;
      return;
    }

    const row = input.closest(".cart-item");
    const equiv = rowCanEquiv(row);
    if (equiv < 1) return;

    const newVal = parseInt(input.value, 10) || 0;
    const prevVal = parseInt(input.getAttribute("value"), 10) || 0;
    const remaining = canTotalFromDom() - (prevVal - newVal) * equiv;
    if (newVal >= prevVal || !wouldLosePerk(remaining)) return;

    // 非同期の確認待ちの間、この操作は一旦すべて止める
    event.preventDefault();
    event.stopPropagation();

    confirmBadgeRemoval(rowProductTitle(row)).then((proceed) => {
      if (proceed) {
        input.dataset.perkConfirmBypass = "1";
        input.dispatchEvent(new Event("change", { bubbles: true, cancelable: true }));
      } else {
        input.value = prevVal;
      }
    });
  }

  function interceptCanRemoveClick(event) {
    const removeButton = event.target.closest("cart-remove-button");
    if (!removeButton) return;

    // 確認モーダルで「削除する」を選んだ後の再送信はそのまま通す
    if (removeButton.dataset.perkConfirmBypass === "1") {
      delete removeButton.dataset.perkConfirmBypass;
      return;
    }

    const row = removeButton.closest(".cart-item");
    const equiv = rowCanEquiv(row);
    if (equiv < 1) return;

    const input = row.querySelector(".quantity__input");
    const rowQty = input ? parseInt(input.getAttribute("value"), 10) || 0 : 0;
    const remaining = canTotalFromDom() - rowQty * equiv;
    if (!wouldLosePerk(remaining)) return;

    event.preventDefault();
    event.stopPropagation();

    confirmBadgeRemoval(rowProductTitle(row)).then((proceed) => {
      if (!proceed) return;
      removeButton.dataset.perkConfirmBypass = "1";
      const link = removeButton.querySelector("a");
      if (link) link.click();
    });
  }

  // 現在のカート行から「追加購入・プレゼント行をどう補正すべきか」を計算する。
  // ・缶換算数が0 → 追加購入・プレゼントの行をすべて削除
  // ・缶換算数が1以上 → 各プレゼント施策（PerkConfig.gifts）ごとに
  //   single(1個だけ)/multiply(条件数ごとに増加) で必要数を計算して補正
  function computeGiftPlan(items) {
    let canCount = 0;
    const giftLines = {}; // variantId -> カート行
    const badgeLineKeys = [];
    items.forEach((item) => {
      canCount += itemCanEquiv(item) * item.quantity;
      const itemType = item.properties ? item.properties["_item_type"] : null;
      if (itemType === "gift") giftLines[String(item.variant_id)] = item;
      if (itemType === "badge" || itemType === "gift") badgeLineKeys.push(item.key);
    });

    if (canCount === 0) {
      return { removeKeys: badgeLineKeys, ops: [] };
    }

    // 施策ごとの必要数を計算する
    const desiredByVariant = {};
    perkGifts.forEach((gift) => {
      const variantId = String(gift.variantId || "");
      if (!variantId || variantId === "null") return;
      const threshold = parseInt(gift.threshold, 10) || 6;
      const mode = gift.mode === "multiply" ? "multiply" : "single";
      desiredByVariant[variantId] =
        canCount >= threshold ? (mode === "multiply" ? Math.floor(canCount / threshold) : 1) : 0;
    });

    const ops = [];
    Object.keys(desiredByVariant).forEach((variantId) => {
      const line = giftLines[variantId] || null;
      const desired = desiredByVariant[variantId];
      const current = line ? line.quantity : 0;
      if (desired !== current) ops.push({ line, variantId, desired });
    });
    // 施策から外れた（設定に存在しない）ギフト行は削除する
    Object.keys(giftLines).forEach((variantId) => {
      if (!(variantId in desiredByVariant)) {
        ops.push({ line: giftLines[variantId], variantId, desired: 0 });
      }
    });

    return { removeKeys: null, ops };
  }

  function giftPlanNeedsCorrection(plan) {
    return plan.removeKeys ? plan.removeKeys.length > 0 : plan.ops.length > 0;
  }

  // 補正が必要なら実行する。変更を行った場合は true を、不要だった場合は false を解決するPromise。
  function applyGiftPlan(plan) {
    if (!giftPlanNeedsCorrection(plan)) return Promise.resolve(false);

    if (plan.removeKeys) {
      const updates = {};
      plan.removeKeys.forEach((key) => (updates[key] = 0));
      return fetch(getRootUrl() + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates }),
      }).then((res) => {
        if (!res.ok) throw new Error("Failed to remove badge lines on can=0: " + res.status);
        return true;
      });
    }

    // カートの競合を避けるため、ギフトの補正は1件ずつ順番に実行する
    let chain = Promise.resolve();
    plan.ops.forEach((op) => {
      chain = chain.then(() => {
        const request = op.line
          ? fetch(getRootUrl() + "cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: op.line.key, quantity: op.desired }),
            })
          : fetch(getRootUrl() + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                items: [
                  {
                    id: op.variantId,
                    quantity: op.desired,
                    properties: { _item_type: "gift" },
                  },
                ],
              }),
            });
        return request.then((res) => {
          if (res.ok) return;
          return res
            .json()
            .catch(() => ({}))
            .then((err) => {
              throw new Error(err.description || "Failed to sync gift quantity: " + res.status);
            });
        });
      });
    });
    return chain.then(() => true);
  }

  // 通常時（カート変更イベントに反応した補正）。補正が発生したら表示を揃えるためリロードする。
  function syncGiftBadge(items) {
    if (syncInProgress) return;
    const plan = computeGiftPlan(items);
    if (!giftPlanNeedsCorrection(plan)) return;

    syncInProgress = true;
    setCheckoutDisabled(true);
    applyGiftPlan(plan)
      .then((changed) => {
        if (changed) window.location.reload();
      })
      .catch((err) => console.error(err))
      .finally(() => {
        syncInProgress = false;
        scheduleCheckoutEnable();
      });
  }

  // 決済ボタン押下時のガード。数量変更リクエストが機内に残っている可能性があるため、
  // ①カート更新がすべて完了するまで待つ → ②最新のカートを取得 → ③缶バッジ数を補正 →
  // ④本来の決済送信を実行、の順で処理する。
  function interceptCheckoutSubmit(event) {
    const form = event.target;
    if (!form || form.id !== "cart") return;

    if (checkoutSubmitBypass) {
      checkoutSubmitBypass = false;
      return;
    }

    // 特典機能に関わる行がまったくないカートでは何もしない（通常購入のお客様に遅延を与えない）
    if (canTotalFromDom() === 0 && !cartBadgeRowsExist()) {
      return;
    }

    // event.submitter は主要ブラウザで対応済みだが、念のためフォーカス中の要素でフォールバックする
    const activeInForm = document.activeElement && document.activeElement.form === form ? document.activeElement : null;
    const submitter = event.submitter || activeInForm;
    if (!submitter || submitter.name !== "checkout") return;

    event.preventDefault();
    event.stopPropagation();

    const originalText = submitter.textContent;
    submitter.disabled = true;
    submitter.textContent = "確認中...";

    // 反応的な補正（syncGiftBadge）と同時に走って二重補正にならないよう、
    // アイドルを確認してから syncInProgress を立てて排他する
    const acquireSyncLock = () =>
      waitForCartIdle(8000).then(() => {
        if (syncInProgress) return acquireSyncLock();
        syncInProgress = true;
      });

    acquireSyncLock()
      .then(() => fetchSettledCart(12))
      .then((cart) => applyGiftPlan(computeGiftPlan(cart.items)))
      .then(() => {
        checkoutSubmitBypass = true;
        submitter.disabled = false;
        submitter.textContent = originalText;
        // セクション再描画でボタンやフォームのノードが差し替わっている可能性があるため取得し直す
        const freshForm = document.getElementById("cart") || form;
        const freshSubmitter =
          document.getElementById("checkout") || document.querySelector('button[name="checkout"]') || submitter;
        freshSubmitter.disabled = false;
        freshForm.requestSubmit(freshSubmitter);
      })
      .catch((err) => {
        console.error("Checkout pre-check failed", err);
        submitter.disabled = false;
        submitter.textContent = originalText;
        alert("カート内容の確認に失敗しました。お手数ですが、もう一度「購入手続きへ」を押してください。");
      })
      .finally(() => {
        syncInProgress = false;
      });
  }
})();
